const Constants = {
    install (Vue) {
        Vue.prototype.$Constants = {
            JOB_STATUS_NEW: 0,
            JOB_STATUS_PENDING: 1,
            JOB_STATUS_COMPLETE: 2,

            JOB_TYPE_ORDER: 1,
            JOB_TYPE_SERVICE: 2,
            JOB_TYPE_CLAIM: 3,

            JOB_FORM_WALKIN: 'walkin',
            JOB_FORM_ONLINE: 'online',
            JOB_FORM_FLEET: 'fleet',
            JOB_FORM_STORE: 'store',
            JOB_FORM_SERVICE: 'service',
            JOB_FORM_CLAIM: 'claim',
            JOB_FORM_INSPECTION: 'inspection',

            PRINT_TYPE_RECEIPT: 'receipt',
            PRINT_TYPE_CLAIM: 'claim',
            PRINT_TYPE_INSPECTION: 'inspection',

            CATEGORY_TIRE: 'tire',
            CATEGORY_ENGINE: 'engine',
            CATEGORY_BATTERY: 'battery',
            CATEGORY_BRAKE: 'brake',
            CATEGORY_ABSORBER: 'absorber',
            CATEGORY_WHEEL: 'wheel',
            CATEGORY_PART: 'part',
            CATEGORY_OTHER: 'other',

            TRANSFER_STATUS_INPROGRESS: 1,
            TRANSFER_STATUS_DONE: 2,

            PAYMENT_METHOD_CASH: '1',
            PAYMENT_METHOD_CREDIT_CARD: '2',
            PAYMENT_METHOD_TRANSFER: '3',
            PAYMENT_METHOD_CHEQUE: '4',

            JOB_ACTION_STATE_OPEN: 'open',
            JOB_ACTION_STATE_UPDATE: 'update',
            JOB_ACTION_STATE_CLOSE: 'close'
        };
    }
}

export default Constants